import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import VueElementLoading from 'vue-element-loading';
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  name: 'stockreport',
  components: {
    Paginate,
    DatePicker,
    download,
    JsonExcel,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      isLoadingforxls: false,
      show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
      csvFieldsForXls: {},
			listReportDataforxls: [],
      totalRows:0,
      listStockReportData: [],
      listStockReportDatacsv: [],
      listStockReportFinalData: [],
      csvFields: [],
      pageno: 0,
      pageCount: 0,
      POID: '',
      InvoiceID: '',
      RackID: '',
      ProductID: '',
      fromdate: '',
      todate: '',
      isLoading: false,
      formattedDate: '',
      resultCount: '',
      listClientData: [],
      listWarehouseData: [],
      ClientErr: '',
      WarehouseErr: '',
      searchFlag: false,
      showSelectWarehouse: false,
      showSelectClient: false,
      user_type: '',

      clientid: '',
      warehouseid: '',
      warehouse: '',
      client: '',
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY hh:mm:ss');
    }
  },
  mounted() {
    var today = new Date();
    this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
    var permissionEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdbyEmail = userdetail.email;
    this.reportname = "stockreport"
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
    //this.getStockReportData();
    this.user_type = userdetail.utype;
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        this.getClientList();
        this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        this.warehouse = this.warehouseid;
        this.showSelectClient = true;
        this.getClientList();

        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }

  },
  methods: {
    Choosetype() {
			this.show = true;
			this.download = false;
			this.getStockReportDataForXls(3)
		},
    startDownload(){
    this.isLoadingforxls =true;
    },
    finishDownload(){
    this.isLoadingforxls =false;
    },
    export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    getClientList() {
      this.listClientData = '';
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');

      this.input = ({
        warehouseid: this.warehouseid,
      });

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          this.listClientData = result.data.data;
        }, error => {
          console.error(error);
        });
    },
    getWarehouseList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.pageno = 0;
      this.input = ({
        clientid: this.clientid,
      });

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          // console.log(result.data.data);
          this.listWarehouseData = result.data.data;
        }, error => {
          console.error(error)
        })
    },
    clientSelected() {
      if (this.clientid != this.client) {
        this.clientid = this.client;
        if (this.user_type != 'warehouse_user') {
          this.listWarehouseData = []
          this.getWarehouseList();
          if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
            this.warehouse = this.warehouseid = '';
          } else {
            this.warehouse = ''
          }
        } else {
          if (this.warehouseid && this.clientid);
          // this.getStockReportData();
        }
      }
      this.listStockReportData = [];
      this.pageno = this.pageCount = 0;
    },

    warehouseSelected() {
      this.warehouseid = this.warehouse;
      this.pageno = this.pageCount = 0;
      if (this.warehouseid) {
        if (this.clientid) {
          // console.log(this.warehouse);
          // this.getStockReportData();
        } else {
          this.getClientList();
        }
      }
    },
    getStockReportDataSearch() {
      this.pageno = 0;
      this.pageCount = 0;
      this.searchFlag = true;
      this.getStockReportData(2);
    },
    //to get client list
    getStockReportData(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var fr_date = '';
      var to_date = '';
      var dataFilter = {};
      if (csvCheck == 2){
        this.show=false;
        this.download =true;
      }
      // this.ClientErr = '';
      if (this.clientid == '' || this.client == '') {
        this.ClientErr = 'Client is required';
        this.pageNo = this.pageCount = 0;
        this.listStockReportData = [];
        return false;
      }
      if (this.warehouseid == '' || this.warehouse == '') {
        this.WarehouseErr = this.$t('common.warehouseError');
        this.pageNo = this.pageCount = 0;
        this.listStockReportData = [];
        return false;
      }

      if (this.fromdate) {
        fr_date = this.dateFormat(this.fromdate)
      }
      if (this.todate) {
        to_date = this.dateFormat(this.todate)
      }
      this.isLoading = true;
      if (csvCheck == 2)
        this.pageno = 0;
      this.input = ({
        offset: this.pageno,
        limit: 10,
        fromddate: fr_date,
        todate: to_date,
        pono: this.POID,
        productid: this.ProductID,
        rackid: this.RackID,
        csvData: csvCheck,
        clientid: this.clientid,
        warehouseid: this.warehouseid,
      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          dataFilter[k] = v;
        }
          })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'stockReport',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (csvCheck == 1) {
            this.show = true;
            this.download = false;
            this.listStockReportDataCsv = [];
            this.csvFields = {
              'pono': 'PO Number',
              'rackid': 'RackId',
              'clientproductid': 'Client product ID',
              'productname': 'Product Name',
              'productid': 'Product Id',
              'mrp': 'Mrp',
              'storeinquantity': 'Accepted qty',
              'rackindatetime': 'Rackin Date',
              'expirydate': 'Expiry Date'
            };
            var dateFilter = ['rackindatetime', 'expirydate'];
            var skipFilter = ['invreferenceid'];
            this.listStockReportDataCsv = result.data.data;
            csvHelper.data.jsonToCSV('StockReport', this.listStockReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

            // this.jsonToCSV('StockReport', this.listStockReportDataCsv, this.csvFields, dateFilter, skipFilter);
          } else {
            this.listStockReportData = result.data.data
            if (result.data.errorCode == -1) {
              this.resultCount = 0
            } else {
               this.totalRows = result.data.count
              this.resultCount = result.data.count
              if (this.totalRows < 10) {
                this.pageCount = 1
              } else {
                this.pageCount = Math.ceil(this.totalRows / 10)
              }
            }
          }

          this.isLoading = false;
        }, error => {
          console.error(error)
        })
    },
    getStockReportDataForXls(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var fr_date = '';
      var to_date = '';
      this.show = true;
      this.download = false;
      this.dataFilter2 = [];
      var value = '';
      var str = '';
      // this.ClientErr = '';

      if (this.fromdate) {
        fr_date = this.dateFormat(this.fromdate)
      }
      if (this.todate) {
        to_date = this.dateFormat(this.todate)
      }

      if (csvCheck == 2)
        this.pageno = 0;
      this.input = ({
        offset: this.pageno,
        limit: 10,
        fromddate: fr_date,
        todate: to_date,
        pono: this.POID,
        productid: this.ProductID,
        rackid: this.RackID,
        csvData: csvCheck,
        clientid: this.clientid,
        warehouseid: this.warehouseid,
      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          value += k + ':' + v + ','
          this.dataFilter2 = str.concat(value);

        }
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'stockReport',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (csvCheck == 3) {
              if (result.data.data.length > 0) {
                this.listReportDataforxls = [];
                this.csvFieldsForXls = {
                   'PO Number':'pono',
                   'RackId':'rackid',
                   'Client product ID':'clientproductid',
                   'Product Name':'productname',
                   'Product Id':'productid',
                   'Mrp':'mrp',
                   'Accepted qty':'storeinquantity',
                   'Rackin Date':'rackindatetime',
                   'Expiry Date':'expirydate'
                };

                this.listReportDataforxls = result.data.data;
              }
              else {
                  if (result.data.status == true) {
                    this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
                  } else {
                    this.$alertify.error(result.data.msg.message);
                  }
                }


          }


        }, error => {
          console.error(error)
        })
    },
    //to get pagination
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 10
      this.getStockReportData();
    },
    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    dateFormatFRT(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    },
    //to reset search form
    resetSearchForm() {
      this.show=false;
      this.download =true;
      this.POID = '';
      this.InvoiceID = '';
      this.RackID = '';
      this.ProductID = '';
      this.fromdate = '';
      this.todate = '';
      this.totalRows =0;
      this.pageno = this.pageCount = 0;
      this.listStockReportData = [];
      this.searchFlag = false;
      if (this.user_type == 'warehouse_user')
        this.client = '';
      else if (this.user_type == 'client_user')
        this.warehouse = '';
      else {
        this.client = '';
        this.warehouse = '';
      }
      //this.getStockReportData();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/reports/stockreport/stockreport.component.js